import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';

/**
 * Shared QueryClient instance.
 *
 * Configuration:
 * - staleTime: 60 s — avoids refetch on every remount for typical list views
 * - retry: 1 — one retry on transient errors; auth errors (401/403) should
 *   NOT be retried (handled by the API client interceptor)
 * - throwOnError: false — let each query/mutation decide whether to throw
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 0,
    },
  },
});

interface QueryProviderProps {
  children: ReactNode;
}

export function QueryProvider({ children }: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}

/** Exported for use in tests that need a fresh client per test. */
export { queryClient };
